import React, { useCallback, useEffect, useState } from "react";
import "./EingereichteLeads.scss";
import PlusIcon from "../../../assets/images/plus.svg";
import { ApiGet, ApiPost, ApiPut } from "../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import ReactApexCharts from "react-apexcharts";
import newimage from "../../../../src/assets/icon/icon.svg";
import icon from "../../../../src/assets/icon/Frame 3000.svg";
import AddMonestizel from "./leadsModel";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ConfirmationModal from "../Verfügbarkeit/Modal";
import WorkingDays from "../Verfügbarkeit/WorkingDays";
import CountUp from "react-countup";
import { calculateDatePercentage, checkSubarrayLength, generateDateRange, getCurrentMonthDates, getEndDateOfMonth, groupDateRanges } from "../Verfügbarkeit/Functions";
import { Calendar } from "react-multi-date-picker";
import { number } from "prop-types";
import moment from "moment";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

Chart.register(ArcElement, Tooltip, Legend);

export default function EingereichteLeads() {
  const [neueLeadsData, setNeueLeadsData] = useState(0);
  const [projekteData, setProjekteData] = useState(0);
  const [kalendarData, setKalendarData] = useState(0);

  const totalLengthTicket =
  projekteData && projekteData.reduce((sum, item) => sum + item?.data?.length, 0);

  const getNewLeadData = async () => {
    try {
      let resp = await ApiGet(`vattenfall/getNewLead?page=${1}&limit=${10}`);
      setNeueLeadsData(resp?.data?.payload?.count);
    } catch (error) {
      console.log(error);
    }
  };

  const getProjekteData = async () => {
    try {
      let resp = await ApiGet(`vattenfall/getConformLead`);
      setProjekteData(resp?.data?.payload?.findConform);
    } catch (error) {
      console.log(error);
    }
  };

  const getCalenderData = async () => {
    try {
      let resp = await ApiGet(`vattenfall/getSelectDateLead`);
      setKalendarData(resp?.data?.payload?.count);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getNewLeadData();
    getProjekteData();
    getCalenderData();
  }, []);






  return (
    <>
      <div className="col-lg-12 col-xxl-12 p-0">
        <div className="row">

          <div className="col-xl-3 col-md-6 mb-4">
            <NavLink className="" to="/newlead">
              <div className="card rounded-3 border-5 border-bottom shadow h-100 py-2">
                <div className="card-body cursor-pointer">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-sjma text-uppercase mb-1">Neue Leads</div>
                      <div className="h5 mb-0 font-weight-bold text-danger-800">
                        <CountUp end={neueLeadsData || 0} />
                      </div>
                    </div>
                    <div className="col-auto">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.04856 1.19083C8.85377 0.996108 8.58963 0.886719 8.31421 0.886719C8.03879 0.886719 7.77464 0.996108 7.57986 1.19083L0.675741 8.09391C0.627455 8.1422 0.589152 8.19952 0.56302 8.26261C0.536888 8.3257 0.523438 8.39332 0.523438 8.4616C0.523438 8.52989 0.536888 8.59751 0.56302 8.6606C0.589152 8.72369 0.627455 8.78101 0.675741 8.8293C0.773259 8.92682 0.905523 8.9816 1.04343 8.9816C1.11172 8.9816 1.17934 8.96815 1.24243 8.94202C1.30552 8.91589 1.36284 8.87758 1.41113 8.8293L8.31421 1.92518L15.2173 8.8293C15.3148 8.92682 15.4471 8.9816 15.585 8.9816C15.7229 8.9816 15.8552 8.92682 15.9527 8.8293C16.0502 8.73178 16.105 8.59952 16.105 8.4616C16.105 8.32369 16.0502 8.19143 15.9527 8.09391L13.5076 5.64989V2.22951C13.5076 2.09177 13.4529 1.95968 13.3555 1.86228C13.2581 1.76489 13.126 1.71017 12.9883 1.71017H11.9496C11.8119 1.71017 11.6798 1.76489 11.5824 1.86228C11.485 1.95968 11.4303 2.09177 11.4303 2.22951V3.57253L9.04856 1.19083Z"
                          fill="#9F9F9F"
                        />
                        <path
                          d="M8.31022 3.05078L14.5423 9.28287V13.6526C14.5423 14.0658 14.3782 14.4621 14.086 14.7543C13.7938 15.0465 13.3975 15.2106 12.9843 15.2106H3.63615C3.22293 15.2106 2.82665 15.0465 2.53446 14.7543C2.24227 14.4621 2.07813 14.0658 2.07812 13.6526V9.28287L8.31022 3.05078Z"
                          fill="#9F9F9F"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          <div className="col-xl-3 col-md-6 mb-4">
            <NavLink className="" to="/projekte">
              <div className="card rounded-3 border-5 border-bottom shadow h-100 py-2">
                <div className="card-body cursor-pointer">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-sjma text-uppercase mb-1">Projekte</div>
                      <div className="h5 mb-0 font-weight-bold text-danger-800">
                        <CountUp end={totalLengthTicket || 0} />
                      </div>
                    </div>
                    <div className="col-auto">
                      <svg
                      width="25"
                      height="25"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.777477 12.5885H7.16914V10.0885H2.66914C1.88581 10.0885 1.21081 10.6302 1.04414 11.3969L0.777477 12.5885ZM8.83581 12.5885H15.2275L14.9608 11.3969C14.8779 11.0271 14.672 10.6965 14.3769 10.4588C14.0817 10.2212 13.7147 10.0907 13.3358 10.0885H8.83581V12.5885ZM15.5941 14.2552H8.83581V17.5885H14.2608C15.3275 17.5885 16.1191 16.6052 15.8858 15.5635L15.5941 14.2552ZM1.74414 17.5885H7.16914V14.2552H0.410811L0.119144 15.5635C-0.11419 16.6052 0.677477 17.5885 1.74414 17.5885ZM8.00248 5.92188C7.54414 5.92188 7.16914 6.29688 7.16914 6.75521V7.58854C7.16914 8.04688 7.54414 8.42188 8.00248 8.42188C8.46081 8.42188 8.83581 8.04688 8.83581 7.58854V6.75521C8.83581 6.29688 8.46081 5.92188 8.00248 5.92188ZM13.4941 6.43854C13.5714 6.36145 13.6327 6.26987 13.6745 6.16906C13.7163 6.06825 13.7378 5.96018 13.7378 5.85104C13.7378 5.7419 13.7163 5.63383 13.6745 5.53302C13.6327 5.43221 13.5714 5.34064 13.4941 5.26354L12.9025 4.67188C12.8253 4.59472 12.7337 4.53352 12.6329 4.49177C12.5321 4.45002 12.4241 4.42852 12.315 4.42852C12.2059 4.42852 12.0978 4.45002 11.997 4.49177C11.8962 4.53352 11.8046 4.59472 11.7275 4.67188C11.6503 4.74903 11.5891 4.84062 11.5474 4.94142C11.5056 5.04223 11.4841 5.15027 11.4841 5.25937C11.4841 5.36848 11.5056 5.47652 11.5474 5.57733C11.5891 5.67813 11.6503 5.76972 11.7275 5.84687L12.3191 6.43854C12.6441 6.76354 13.1691 6.76354 13.4941 6.43854ZM3.68581 6.43854L4.27748 5.84687C4.35463 5.76972 4.41583 5.67813 4.45758 5.57733C4.49934 5.47652 4.52083 5.36848 4.52083 5.25937C4.52083 5.15027 4.49934 5.04223 4.45758 4.94142C4.41583 4.84062 4.35463 4.74903 4.27748 4.67188C4.20033 4.59472 4.10873 4.53352 4.00793 4.49177C3.90713 4.45002 3.79909 4.42852 3.68998 4.42852C3.58087 4.42852 3.47283 4.45002 3.37202 4.49177C3.27122 4.53352 3.17963 4.59472 3.10248 4.67188L2.51081 5.25521C2.43356 5.3323 2.37227 5.42388 2.33045 5.52469C2.28863 5.6255 2.26711 5.73357 2.26711 5.84271C2.26711 5.95185 2.28863 6.05992 2.33045 6.16073C2.37227 6.26154 2.43356 6.35311 2.51081 6.43021C2.83581 6.76354 3.36081 6.76354 3.68581 6.43854ZM2.16914 0.921875H1.33581C0.877477 0.921875 0.502477 1.29687 0.502477 1.75521C0.502477 2.21354 0.877477 2.58854 1.33581 2.58854H2.16914C2.62748 2.58854 3.00248 2.21354 3.00248 1.75521C3.00248 1.29687 2.62748 0.921875 2.16914 0.921875ZM14.6691 0.921875H13.8358C13.3775 0.921875 13.0025 1.29687 13.0025 1.75521C13.0025 2.21354 13.3775 2.58854 13.8358 2.58854H14.6691C15.1275 2.58854 15.5025 2.21354 15.5025 1.75521C15.5025 1.29687 15.1275 0.921875 14.6691 0.921875ZM8.00248 5.08854C10.3025 5.08854 12.1691 3.22187 12.1691 0.921875H3.83581C3.83581 3.22187 5.70248 5.08854 8.00248 5.08854Z"
                        fill="#9F9F9F"
                      />
                    </svg>
                    </div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          <div className="col-xl-3 col-md-6 mb-4">
            <NavLink className="" to="/calendar">
              <div className="card rounded-3 border-5 border-bottom shadow h-100 py-2">
                <div className="card-body cursor-pointer">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-sjma text-uppercase mb-1">Kalendar</div>
                      <div className="h5 mb-0 font-weight-bold text-danger-800">
                        <CountUp end={kalendarData || 0} />
                      </div>
                    </div>
                    <div className="col-auto">
                      <svg
                      width="25"
                      height="25"
                      viewBox="0 0 16 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5 8.25391V14.0872C15.5 14.5293 15.3244 14.9532 15.0118 15.2657C14.6993 15.5783 14.2754 15.7539 13.8333 15.7539H2.16667C1.72464 15.7539 1.30072 15.5783 0.988155 15.2657C0.675595 14.9532 0.5 14.5293 0.5 14.0872V8.25391H15.5ZM11.3333 0.753906C11.5543 0.753906 11.7663 0.841704 11.9226 0.997984C12.0789 1.15426 12.1667 1.36623 12.1667 1.58724V2.42057H13.8333C14.2754 2.42057 14.6993 2.59617 15.0118 2.90873C15.3244 3.22129 15.5 3.64521 15.5 4.08724V6.58724H0.5V4.08724C0.5 3.64521 0.675595 3.22129 0.988155 2.90873C1.30072 2.59617 1.72464 2.42057 2.16667 2.42057H3.83333V1.58724C3.83333 1.36623 3.92113 1.15426 4.07741 0.997984C4.23369 0.841704 4.44565 0.753906 4.66667 0.753906C4.88768 0.753906 5.09964 0.841704 5.25592 0.997984C5.4122 1.15426 5.5 1.36623 5.5 1.58724V2.42057H10.5V1.58724C10.5 1.36623 10.5878 1.15426 10.7441 0.997984C10.9004 0.841704 11.1123 0.753906 11.3333 0.753906Z"
                        fill="#9F9F9F"
                      />
                    </svg>
                    </div>
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

        </div>
      </div>
    </>
  );
}
